import React, { useEffect, useLayoutEffect,  useState } from "react";
import Calendar from "../../Componenten/Calender/Calendar";
import BannerPlannig from "../../Layout/BannerPlannig";
import MonthView from "../../Componenten/Calender/MonthView";
import WeekView from "../../Componenten/Calender/WeekView";
import DayView from "../../Componenten/Calender/DayView";
import UpcomingAgenda from "../../Componenten/Calender/UpcomingAgenda";
import DoubleMeeting from "../../Componenten/Calender/DoubleMeeting";
import {
  setAppointmentLoad,
} from "../../redux/appointmentSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  AXIOS_GET
} from "../../server/api/crud";
import {
  getAdmins,
  getUser,
  getUserdetails,
} from "../../Localstorage/localstorage";
import PatientenView from "../../Componenten/Calender/PatientenView";
import {
  filterEventsByAdminsEmail,
  filterEventsByUserEmail,
} from "../../function";
import { SpinnersMutatingDots } from "../../Componenten/Calender/Spinners";
import moment from "moment";

const Items = [
  { id: 0, name: "Maand", viewComponent: MonthView },
  { id: 1, name: "Week", viewComponent: WeekView },
  { id: 2, name: "Dag", viewComponent: DayView },
  { id: 3, name: "Geplande Afspraken", viewComponent: UpcomingAgenda },
  { id: 4, name: "Patienten", viewComponent: PatientenView },
  { id: 5, name: "Overzicht 2 maanden", viewComponent: DoubleMeeting },
];

const getCalendlyUserUri = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return parsed?.uri || "";
    } catch {
      return "";
    }
  }
  return value?.uri || "";
};

const Planning = () => {
  const user = getUser();
  const userdetails = getUserdetails();
  const admins = getAdmins();
  const gebruiker = userdetails?.role_id === 2 ? admins[0] : userdetails;
  const [isLoading, setIsLoading] = useState(false);

  const [view, setView] = useState(0);
  const dispatch = useDispatch();
  const [select, setSelect] = useState(gebruiker);

  const { appointments,pagination } = useSelector((state) => state.appointment);

  //const { user } = useSelector((state) => state.appointment);

  const getAgenda = async (id) => {
    try {
      setIsLoading(true);
      const email = user?.username.includes('@') ? user?.username : (user?.email ? user?.email : userdetails?.email);
      const queryParams = new URLSearchParams({
        organization:
          "https://api.calendly.com/organizations/e5ba7299-d262-4435-acc9-67a68893e28f",
          count:'100',
        sort: "start_time:asc",
        min_start_time: moment().startOf('month').toISOString(),
        invitee_email:email
      }).toString();


      const responses = await AXIOS_GET(`calendly/events?${queryParams}`);

      //console.log(responses);
      setIsLoading(false); // set false regardless of outcome

      const collection = responses?.data?.collection || [];

      //console.log(collection)
      const arra = await filterEventsByUserEmail(collection, userdetails?.email);

      dispatch(setAppointmentLoad(arra));
    } catch (error) {
      console.error("Error fetching afspraak", error);
    } finally {
      setIsLoading(false);
    }
  };



  const getAgendaAmdin = async (p_date = moment().startOf('month')) => {
    setIsLoading(true); // set loading immediately

    let date =   moment(p_date).startOf('month');
    try {
      const selectedUserUri =
        getCalendlyUserUri(select?.calendly_info) ||
        getCalendlyUserUri(userdetails?.calendly_info);

      const queryPayload = {
        organization: "https://api.calendly.com/organizations/e5ba7299-d262-4435-acc9-67a68893e28f",
        count: '100',
        sort: "start_time:asc",
        min_start_time: date?.toISOString(),
        status: "active",
      };
      if (selectedUserUri) {
        queryPayload.user = selectedUserUri;
      }

      const queryParams = new URLSearchParams(queryPayload).toString();
  
      const responses = await AXIOS_GET(`calendly/events?${queryParams}`);
      setIsLoading(false); // set false regardless of outcome

      const collection = responses?.data?.collection || [];
      const filtered = await filterEventsByAdminsEmail(collection, select?.email);
  
      dispatch(setAppointmentLoad(filtered));

    } catch (error) {
      console.error("Error fetching afspraak", error);
    } finally {
      setIsLoading(false);
    }
  };

  

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (user?.role === 1 && select?.user_id) {
        getAgendaAmdin(pagination);
      } else {
        getAgenda();
      }

      
    }, 100); // wait 500ms before firing

    return () => clearTimeout(delayDebounce);
  }, [select?.user_id, pagination,user?.role]);
  

  useLayoutEffect(() => {
    // Example: Fetch mailrooms when the component mounts

    if (user.role == 2) {
      getAgenda();
    } else {
      // Example: Fetch mailrooms when the component mounts
      getAdmins();
    }
  }, []);

  return (
    <div className="h-full min-h-0 bg-wa-app text-wa-text">
      <BannerPlannig
        bannerName={"Planning"}
        Changeview={setView}
        selected={select}
        setSelected={setSelect}
        index={view}
        views={Items}
      />
      <Calendar
        select={user.role == 2 ? userdetails : select}
        user={user}
        userdetails={userdetails}
        appointments={appointments}
        Component={Items[view]}
      />
      {isLoading && <SpinnersMutatingDots/>}
    </div>
  );
};

export default Planning;
